/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-26 10:50:06
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-02-04 17:30:58
 * @FilePath: /knit-web/src/locale/en-US/user-profile.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  workspaceSettings: {
    title: 'Settings',
    workspace: {
      editTitle: 'Edit Workspace',
      name: 'Workspace Name',
      namePlaceholder: 'Please enter workspace name',
      nameRequired: 'Please enter workspace name',
      description: 'Description',
      descriptionPlaceholder: 'Please enter workspace description (optional)',
      updateSuccess: 'Update successfully',
      updateFailed: 'Update failed',
    },
    members: {
      title: 'Members',
      edit: 'Edit',
      add: 'Add',
      member: 'Member',
      memberCount: 'Member',
      joinedAt: 'Joined At',
      actions: 'Actions',
      me: 'Me',
      owner: 'Owner',
      email: 'Email',
      emailPlaceholder: 'Please enter email address',
      emailRequired: 'Please enter email',
      inviteTitle: 'Invite Member',
      inviteSuccess: 'Invite successfully',
      inviteFailed: 'Invite failed',
      loadFailed: 'Failed to load members',
      userNotFound:
        'No user found with the email. Please check, or the user may not be registered yet.',
      searchFailed: 'Failed to search user',
      pleaseSelectUser: 'Please search and select a user first',
      invitationSent: 'Invitation Sent',
      invitationSentMessage:
        "The invitation has been delivered to the user's in-app inbox. Please ask them to check their messages.",
      backToSettings: 'Back to Settings',
      inviteAnother: 'Invite Another',
      remove: 'Remove',
      removeTitle: 'Remove Member',
      removeMessage:
        'Are you sure you want to remove this member from the workspace? They will lose access to all workspace resources.',
      confirm: 'Confirm',
      cancel: 'Cancel',
      removeSuccess: 'Remove successfully',
      removeFailed: 'Remove failed',
      leaveWorkspace: 'Leave Workspace',
      leaveWorkspaceTitle: 'Leave Workspace',
      leaveWorkspaceMessage:
        'Are you sure you want to leave the workspace? You will lose access to all workspace resources.',
      leaveWorkspaceSuccess: 'Leave Workspace Successfully',
      leaveWorkspaceFailed: 'Leave Workspace Failed',
    },
    resources: {
      title: 'Resources',
      desc: 'Manage your resources',
      knowledge: 'Knowledge Base',
      knowledgeDesc: 'Manage and use knowledge bases',
      nodeTemplate: 'Node Template',
      nodeTemplateDesc: 'Manage and use node templates',
      prompt: 'Prompt Template',
      promptDesc: 'Manage and use prompt templates',
      example: 'Execution Example',
      exampleDesc: 'Manage and use execution examples',
    },
    apiKey: {
      title: 'API Key',
      create: 'Create API Key',
      topTip:
        'To prevent API abuse, protect your API Key. The key will no longer be able to use and cannot be restored once deleted.',
      columns: {
        name: 'Name',
        description: 'Description',
        apiKey: 'API Key',
        runtimeResource: 'Runtime Resource',
        createdAt: 'Created At',
        createdBy: 'Created By',
        lastUsed: 'Last Used',
        never: 'Never',
        actions: 'Actions',
      },
      actions: {
        edit: 'Edit Info',
        copy: 'Copy API Key',
        delete: 'Delete',
        deleteSuccess: 'Delete successfully',
      },
      modal: {
        createTitle: 'Create API Key',
        editTitle: 'Edit API Key',
        name: 'API Key Name',
        namePlaceholder: 'Enter API Key Name',
        autoGenerated: 'Auto-generated if empty',
        required: 'Required',
        createSuccess: 'Create successfully',
        description: 'API Key Description',
        descriptionPlaceholder: 'Enter API key Description',
        secretTitle: 'API Key',
        secretNotice: 'Keep this key in a secure and accessible place.',
        copy: 'Copy',
        copySuccess: 'Copied successfully',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
      },
      deleteConfirm: {
        title: 'Delete Key "{name}"',
        contentUsedPrefix: 'This API key was last used on ',
        contentSuffix:
          '. Deleting it will immediately revoke access and cannot be undone.',
        contentUnused:
          'This API key has not been used yet. Deleting it will immediately revoke access and cannot be undone.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      tips: {
        nameIncrement:
          'Can be incremented based on the existing keys in the workspace. E.g., API Key1.',
        descInfo: 'Used only for the user to identify the API Key.',
      },
    },
    menu: {
      members: 'Members',
      resources: 'Resources',
      apiKey: 'API Key',
      identifiers: 'Identifiers',
    },
    identifiers: {
      title: 'Identifiers',
      description:
        'A Identifier represents a stable execution contract that decouples external integrations from workflow implementations.',
      create: 'Create Identifier',
      column: {
        identifier: 'Identifier',
        target: 'Target',
        lastUsed: 'Last Used',
        actions: 'Actions',
      },
      action: {
        editMeta: 'Edit Meta',
        updateTarget: 'Update Target',
        updateHistory: 'Update History',
        delete: 'Delete',
        open_target_workflow: 'Open Target Workflow',
      },
      message: {
        deleteConfirmTitle: 'Delete Identifier "{name}"',
        deleteConfirmContentUsed:
          'This Identifier was last used on {date}. Deleting it will immediately revoke access and cannot be undone.',
        deleteConfirmContentUnused:
          'This Identifier has not been used yet. Deleting it will immediately revoke access and cannot be undone.',
        deleteSuccess: 'Deleted successfully',
        createdSuccess: 'Identifier created successfully',
        updatedSuccess: 'Identifier updated successfully',
        targetUpdatedSuccess: 'Identifier target updated successfully',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      createModal: {
        title: 'Create Identifier',
        name: 'Identifier Name',
        namePlaceholder: 'Examples: login_reward',
        nameHelp:
          'Unique within the workspace. Letters, numbers, and underscores only. Must start with a letter. Immutable after creation.',
        nameRequired: 'Identifier Name is required',
        namePattern:
          'Must start with a letter and contain only letters, numbers, and underscores',
        desc: 'Identifier Description',
        descPlaceholder: 'Enter Identifier Description',
      },
      editModal: {
        title: 'Edit Identifier',
        nameTooltip: 'Name cannot be modified after creation',
      },
      targetModal: {
        title: 'Update Identifier',
        latestTarget: 'Current Target',
        noTarget: 'No target selected',
        unknownWorkflow: 'Unknown Workflow',
        updateTo: 'Update To',
        targetWorkflow: 'Target Workflow',
        selectWorkflow: 'Select Workflow',
        targetVersion: 'Target Version',
        selectVersion: 'Select Version',
        versionDesc: 'Version Description',
        updatedAt: 'Updated At',
        by: 'By',
        selectRequired: 'Please select a target workflow and version',
      },
      historyModal: {
        title: 'Update History',
        targetWorkflow: 'Target Workflow',
        targetVersion: 'Target Version',
        updatedAt: 'Updated At',
        updatedBy: 'Updated By',
      },
      never: 'Never',
    },
  },
};
